<template>
	<div id="compensate" class="page" v-if="loaded">
		<div class="title">
			<div class="li lft"></div>
			<div class="txt">{{this.$store.state.config.data.compencate_title}}</div>
			<div class="li rgt"></div>
		</div>
		<div class="tip">{{this.$store.state.config.data.compencate_tip}}</div>
		<div class="compensate_box">
			<div class="line" v-on:click="event_subject(item)" v-for="item in compencateList">
				<div class="image">
					<img v-bind:src="item.icon"/>
				</div>
				<div class="info">
					<div class="title">{{item.subject}}</div>
					<div class="content">{{item.description}}</div>
				</div>
				<div class="right"><span>></span></div>
				<div class="over" v-if="item.pass"></div>
				<div class="nover" v-if="!item.pass"></div>
			</div>
		</div>
		<div class="btn" v-if="!sq.payed && compencatepower" v-on:click="event_form">立即申请</div>
		<div class="btn cantuse" v-if="sq.payed && compencatepower" v-on:click="event_form">您已经获得过赔付了</div>
		<div class="btn disabled" v-if="!compencatepower" v-on:click="event_vip">立即开通（{{compencate.subject}}）</div>
		<div class="infobox" style="line-height:7vw;font-size:3.7vw;color:#717171;padding:3vw 0vw;" v-html="this.$store.state.config.data.compencate_info"></div>
	</div>
</template>

<script>
import { Toast , Dialog} from 'we-vue'
export default {
	data () {
		return {
			compencateList:[],
			compencatepower:false,
			compencate:{},
			sq:{},
			loaded:false
		}
	},
	created () {
		this.$https.post("/api/compensate/index",this.$qs.stringify({
			token:this.$store.state.token
		})).then((res) => {
			this.sq = res.data.data.sq ? res.data.data.sq : {}
			this.compencateList = res.data.data.compencateList
			this.compencate = res.data.data.compencate
			this.compencatepower = res.data.data.compencatepower
			this.loaded = true;
		}).catch(() => {
			
		});
	},
	methods: {
		event_subject(item){
			var that = this;
			if (!this.compencatepower){
				Dialog.confirm({
					title: '提示',
					message: '您需要开通VIP才能继续',
					skin:'ios',
					showCancelButton: true
				}).then(() => {
					this.event_vip();
				}).catch(() => {})
			}else{
			  for (var n in this.compencateList){
				if (this.compencateList[n].id == item.id){
				  break;
				}
				if (this.compencateList[n].pass == false){
					
					Toast.text({
						duration: 1000,
						message: '请按顺序完成答卷'
					})
					return false;
				}
			  }
			  if (item.pass){
				  Toast.text({
						duration: 1000,
						message: '您已通过此考核，无须重复答题'
					})
			  }else{
				this.$wx.navigateTo({
				  url: '/fee?compensate=' + item.id + '&subject_type=compensate',
				})
			  }
			}
		},
		event_vip(){
			this.$router.push({path: '/vip', query: {
				vip_id:this.compencate.id
			}});
		},
		event_form(){
			console.log(this.sq.vmCount);
			if(!this.sq || this.sq.payed == undefined){
				Toast.text({
					duration: 1000,
					message: '请依次通过以上考核'
				})
			}else{
				if(this.sq.payed){
					Toast.text({
						duration: 1000,
						message: '您已经获得过赔付了'
					})
				}else{
					this.$router.push('/compensateform')
				}
			}
		}
	},
	filters: {
    
	}
}
</script>

<style scoped>

	#compensate{
		background-color:#fafafa;
		min-height:100vh;
		padding:8vw 3vw;
	}
.title{
  display:flex;
}
.title div.li{
  flex:1;
  position:relative;
}
.title div.txt{
  font-size:5.2vw;
  color:coral;
  height:7vw;
  line-height:7vw;
}
.title div.li:before{
  content:'';
  display:block;
  position:absolute;
  width:70%;
  height:1px;
  border-bottom:1px solid coral;
  top:50%;
}
.title div.li.lft:before{
  right:10px;
}
.title div.li.rgt:before{
  left:10px;
}
.title div.li:after{
  content:'';
  display:block;
  position:absolute;
  width:6px;
  height:6px;
  border-radius:3px;
  background-color:coral;
  top:50%;
  margin-top:-1.5px;
}
.title div.li.lft:after{
  right:10px;
}
.title div.li.rgt:after{
  left:10px;
}
.tip{
  text-align:center;
  margin:3vw 0vw;
  color:#ff7474;
  font-size:3.7vw;
}
.compensate_box{
  border-radius:2vw;
  position:relative;
  padding:0vw 3vw;
  background-color:#FFFFFF;
  border:5vw;
  box-shadow:0px 0px 6px #FFFFFF;
  border:1px solid #ececec;
}
.compensate_box .line{
  position:relative;
  display:flex;
  border-bottom:1px solid #ececec;
  padding:0vw 0vw;
}
.compensate_box .line:last-child{
  border-bottom:0px;
}
.compensate_box .line > div.info{
  flex:1;
}
.compensate_box .line img{
  width:18vw;
  height:18vw;
  margin-top:2vw;
  margin-left:2vw;
  margin-right:4vw;
}
.compensate_box .line > div.img{
  height:20vw;
  width:24vw;
}
.compensate_box .title{
  font-size:4.4vw;
  color:#262626;
  margin-bottom:3vw;
  margin-top:3vw;
}
.compensate_box .content{
  font-size:3.7vw;
  line-height:6vw;
  color:#9d9d9d;
}
.compensate_box .right{
  width:5vw;
  line-height:22vw;
  color:#9d9d9d;
  
}
.compensate_box .right span{
  transform:scaleX(0.5);
  width:5vw;
  display:block;
  height:100%;
  transform:scaleY(2);
}
.compensate_box .over{
  width:12vw;
  height:12vw;
  right:-3vw;
  top:0px;
  position:absolute;
  background-repeat:no-repeat;
  background-position:center centerl;
  background-size:100%;
  background-image:url("data:image/png;base64,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");
}
.compensate_box .nover{
  width:12vw;
  height:12vw;
  right:-3vw;
  top:0px;
  position:absolute;
  background-repeat:no-repeat;
  background-position:center centerl;
  background-size:100%;
  background-image:url("data:image/png;base64,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");
}
.btn{
  display:block;
  height:13vw;
  background-color:#2cd5ff;
  font-size:4.3vw;
  bottom:0px;
  width:100%;
  text-align:center;
  line-height:13vw;
  z-index:100;
  color:#FFFFFF;
  margin-top:3vw;
  border-radius:2vw;
}
.btn.disabled{
  background-color:#b80000;
}
.btn.cantuse{
  background-color:#DDDDDD;
}
</style>


// WEBPACK FOOTER //
// src/components/Compensate.vue